export const dropdownTopCountries = new Set(['GB', 'US'])
export const dropdownTopLangs = new Set(['en_GB', 'en_US'])

// from GET '/template/product'
export const excludeTemplateIds = [6252] // using 6763 instead

export const allowedTemplateIndustries = ['EV', 'CE']

// used for Rapid and Template surveys
export const defaultProdDetails = {
    numVisitors: 250,
    numExhibitors: 5,
    venueId: 1,
    template: {
        startDate: new Date().toISOString(),
        closeDate: '2075-01-01',
    },
}

export const surveyOptionEnum = {
    CLIENT_TEMPLATE: 0,
    EXPLORI_TEMPLATE: 1,
    CLIENT_SURVEYS: 2,
    MAXBI_COMPLETE: 3,
    MAXBI_COPY: 4,
    BLANK_SURVEY: 5,
}

export const exploriTemplateAccess = [{ oid: 3, rid: 1 }]
